import React, {useCallback, useEffect, useRef, useState} from 'react';
import PtrnContainerSimple from '../components/PtrnContainerSimple';
import {Box, Button, Collapse, Grid, IconButton, Typography} from '@mui/material';
import PtrnTituloGridHeader from '../components/PtrnTituloGridHeader';
import CloseIcon from '@mui/icons-material/Close';
import Copyright from '../../atomicos/Copyright';
import {makeStyles} from 'tss-react/mui';
import {PtrnAcercaDeProps} from './PtrnAcercaDeTypes';

const useStyles = makeStyles()((theme) => ({
   copyright: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0)
   }
}));

const PtrnAcercaDe = ({
   nombreApp,
   urlImgApp,
   fechaActualizacion,
   version,
   commit,
   dependenciaList,
   urlTerminosUso,
   urlPoliticasPrivacidad,
   fetchData,
   onClose,
   entidadCopyright,
   urlEntidadCopyright,
   anioLanzamientoCopyright
}: PtrnAcercaDeProps) => {
   const idCompPrefix = 'ptrn-acerca-de';
   const {classes, cx} = useStyles();
   const [showExtraInfo, setShowExtraInfo] = useState(false);
   const [clickCount, setClickCount] = useState(0);
   const timerRef = useRef(null);

   const handleVersionClick = useCallback(() => {
      setClickCount((prevCount) => {
         const newCount = prevCount + 1;
         if (newCount === 9) {
            setShowExtraInfo(true); // Muestra la información adicional cuando se hagan 9 clics
         }
         return newCount;
      });

      if (timerRef.current) {
         clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => setClickCount(0), 1000);
   }, []);

   useEffect(() => {
      return () => {
         if (timerRef.current) {
            clearTimeout(timerRef.current);
         }
      };
   }, []);

   useEffect(() => {
      if (showExtraInfo && fetchData) {
         fetchData();
      }
   }, [showExtraInfo]);

   return (
      <PtrnContainerSimple id={`${idCompPrefix}-container`}>
         <Grid
            id={`${idCompPrefix}-grid-root`}
            container
            direction="column"
            justifyContent="space-between"
            spacing={2}
         >
            <PtrnTituloGridHeader idPrefix={idCompPrefix} titulo={`Acerca de ${nombreApp}`} />
            <Grid container item spacing={2} lg={6} md={8} sm={10} xs={12}>
               <Grid item xs={12}>
                  <img src={urlImgApp} alt={`Imagen de ${nombreApp}`} width="100%" />
               </Grid>
               <Grid item container xs={12} spacing={1}>
                  <Grid item xs={12}>
                     <Box
                        sx={{
                           borderRadius: '10px',
                           border: '1px solid #CECECE',
                           p: 2
                        }}
                     >
                        <Typography variant="h5" onClick={handleVersionClick}>
                           {nombreApp} {version}
                        </Typography>
                        {fechaActualizacion && (
                           <Typography variant="h5">
                              Fecha Actualización: {fechaActualizacion}
                           </Typography>
                        )}
                        {commit && <Typography variant="h5">Commit: {commit}</Typography>}
                     </Box>
                  </Grid>
                  <Grid item container xs={12}>
                     <Collapse in={showExtraInfo} sx={{width: '100%'}}>
                        <Box
                           sx={{
                              borderRadius: '10px',
                              border: '1px solid #CECECE',
                              p: 2
                           }}
                        >
                           <Grid container justifyContent="space-between" alignItems="center">
                              <Typography variant="h5"> Versiones de dependencias</Typography>
                              <IconButton
                                 color="error"
                                 size="small"
                                 onClick={() => {
                                    setShowExtraInfo(false);
                                    if (onClose) onClose();
                                 }}
                              >
                                 <CloseIcon fontSize="inherit" />
                              </IconButton>
                           </Grid>
                           {dependenciaList && dependenciaList.length > 0 && (
                              <Grid container spacing={1}>
                                 {dependenciaList.map((depen, index) => (
                                    <Grid
                                       item
                                       container
                                       spacing={0}
                                       xs={12}
                                       key={depen.app || index}
                                    >
                                       <Grid item xs={12} md={4}>
                                          <Typography variant="h6" fontWeight="bold">
                                             {depen.app}
                                          </Typography>
                                       </Grid>
                                       <Grid item container xs={12} md={8}>
                                          <Grid item xs={12} sm={6}>
                                             <Typography variant="h6">
                                                Versión: {depen.version}
                                             </Typography>
                                          </Grid>
                                          <Grid item xs={12} sm={6}>
                                             <Typography variant="h6">URL: {depen.url}</Typography>
                                          </Grid>
                                       </Grid>
                                    </Grid>
                                 ))}
                              </Grid>
                           )}
                        </Box>
                     </Collapse>
                  </Grid>
               </Grid>
               {(urlTerminosUso || urlPoliticasPrivacidad) && (
                  <Grid item xs={12} container justifyContent="space-between">
                     {urlTerminosUso && (
                        <Button
                           color="primary"
                           component="a"
                           href={urlTerminosUso}
                           variant="contained"
                           target="_blank"
                        >
                           Términos de uso
                        </Button>
                     )}
                     {urlPoliticasPrivacidad && (
                        <Button
                           color="primary"
                           component="a"
                           href={urlPoliticasPrivacidad}
                           variant="contained"
                           target="_blank"
                        >
                           Politicas de privacidad
                        </Button>
                     )}
                  </Grid>
               )}
               <Grid item xs={12}>
                  <Copyright
                     className={classes.copyright}
                     entidad={
                        entidadCopyright && entidadCopyright != ''
                           ? entidadCopyright
                           : 'Data Service'
                     }
                     urlEntidad={
                        urlEntidadCopyright && urlEntidadCopyright != ''
                           ? urlEntidadCopyright
                           : 'https://www.dscont.pe/'
                     }
                     anioLanzamiento={anioLanzamientoCopyright ? anioLanzamientoCopyright : null}
                  />
               </Grid>
            </Grid>
         </Grid>
      </PtrnContainerSimple>
   );
};

export default PtrnAcercaDe;
